import React from "react";

const Dropdown = ({
  options,
  className,
  title,
  onChange,
  name,
  value,
  edit,
}) => {
  return (
    <>
      <select
        class={`form-select ${className}`}
        aria-label="Default select example"
        onChange={onChange}
        name={name}
        value={value}
      >
        {edit ? (
          <option disabled>Select {title}</option>
        ) : (
          <option selected>Select {title}</option>
        )}

        {options &&
          options?.map((option, key) => {
            return (
              <>
                <option value={option} className="text-capitalize">
                  {option}
                </option>
              </>
            );
          })}
      </select>
    </>
  );
};

export default Dropdown;
